import { Button } from "../../../shadcn/Button"
import { Stepper } from "./Stepper"

type Props = {
  email: string
  onClose?: () => void
  buttonText?: string
}

export const SignupComplete = ({ email, onClose, buttonText = "閉じる" }: Props) => {
  return (
    <div className="flex w-full max-w-[800px] flex-col items-start rounded-xl bg-white p-8">
      <div className="mb-12 w-full">
        <Stepper currentStep={2} />
      </div>
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">受信メールをご確認ください</h2>

      <div className="mb-16 w-full text-base leading-[1.5] text-gray-800">
        <p className="mb-0">{email} 宛に確認メールを送信しました。</p>
        <p className="mb-0">（メールの受信まで1-2分程度かかる場合があります。）</p>
        <p className="mb-0">&nbsp;</p>
        <p className="mb-0">メールに記載のURLをクリックして、ユーザー登録を完了させてください。</p>
        <p>URLの有効期限は30日間です。</p>
      </div>

      <div className="flex w-full justify-center">
        <Button
          onClick={onClose}
          className="w-[240px] rounded-3xl bg-green-600 px-[22px] py-2 text-[15px] font-medium text-white hover:bg-green-700"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
